import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { finalize } from "rxjs/operators";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { GetActivityItemResponse, PatientClient } from "../../../api";

export class ActivityViewerDialogData {
    itemId: number;
    timestamp: number;
}

@Component({
    selector: "activity-viewer",
    templateUrl: "./activity-viewer.component.html",
    styleUrls: ["./activity-viewer.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class ActivityViewerComponent implements OnInit {
    comments: string;

    title: string;

    description: string;

    constructor(
        private _progressBarService: FuseProgressBarService,
        public dialogRef: MatDialogRef<ActivityViewerComponent>,
        @Inject(MAT_DIALOG_DATA) public _data: ActivityViewerDialogData,
        private _api: PatientClient
    ) {
        this.dialogRef.addPanelClass("activity-viewer-dialog");
    }

    ngOnInit(): void {
        this._progressBarService.show();
        this._api
            .getActivity(this._data.itemId, this._data.timestamp)
            .pipe(
                finalize(() => {
                    this._progressBarService.hide();
                })
            )
            .subscribe((result: GetActivityItemResponse) => {
                this.comments = result.comments;
                this.title = result.name;
                this.description = result.description;
            });
    }
}
